import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Stamp } from '../models/stamp';

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  baseUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) { }


  uploadFile(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post(`${this.baseUrl}/api/upload`, formData);
  }

  redactFile(file: String): Observable<string> {
    // const formData: FormData = new FormData();
    // formData.append('file', file);
    return this.httpClient.post(`${this.baseUrl}/api/Redaction`, file, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text'});
  }

  retrieveStamps(): Observable<Stamp[]> {
    console.log("In retrieveStamps");
    var result = this.httpClient.get<Stamp[]>(`${this.baseUrl}/api/stamp`);
    console.log("retrieveStamps result: \n", result);

    return result;
  }

  retrieveStampById(stampId: string): Observable<string> {
    return this.httpClient.get(`${this.baseUrl}/api/stamp/request/${stampId}`, { responseType: 'text' });
  }

  getAvailableStampsList(userId: number): Observable<Stamp[]> {
    return this.httpClient.get<Stamp[]>(`${this.baseUrl}/api/stamp/available/${userId}`);
  }


  getDocument(documentId: number): Observable<string> {
    return this.httpClient.get(`${this.baseUrl}/api/document/${documentId}`, { responseType: 'text' });
  }

  stampDocument(file: string, stampId: string): Observable<string> {
    return this.httpClient.post(`${this.baseUrl}/api/stamp/document`, { file, stampId }, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' });
  }
}